import AccountIcon from "./icons/AccountIcon";

type AvatarProps = {
  avatarUrl: string;
  className?: string;
};
const Avatar = (props: AvatarProps) => {
  const { avatarUrl = "", className = "" } = props;
  if (avatarUrl) {
    return <img src={avatarUrl} alt="" className={className} />;
  }
  return <AccountIcon />;
};
export default Avatar;
